import React from "react";
import { Grid, Stack } from "@mzc-pdc/ui";

export const PageTools = ({ search, actions, filters }) => {
    return (
        <>
            <Grid container flexDirection={"row"} mb={1.5} gap={2} pl={`1px`} alignItems={"center"}>
                <Stack direction="row" alignItems={"center"} flex={1}>
                    <Grid item xs={12}>
                        {search && search}
                    </Grid>
                </Stack>
                {actions && <Grid item>{actions}</Grid>}
            </Grid>
        </>
    );
};
